import { StandardEvents } from '@shopify/events';

class AniarcsYukimiyaOffer extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.data = JSON.parse(this.querySelector('[data-offer-data]').textContent);
    this.ids = new Set(this.data.qualifyingIds.map(String));
    this.dialog = this.querySelector('dialog');
    this.error = this.querySelector('[data-error]');
    this.button = this.querySelector('[data-add]');
    this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency: this.data.currency
    });
    this.querySelector('[data-offer-price]').textContent = this.money.format(
      (this.data.price - Math.floor(this.data.price * 0.1)) / 100
    );
    this.querySelectorAll('[data-close]').forEach(button => {
      button.addEventListener('click', () => this.dialog.close(), { signal });
    });
    this.dialog.addEventListener('click', event => {
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    }, { signal });
    this.button.addEventListener('click', () => this.addGlasses(), { signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, event => this.onCartAdd(event), { signal });
    document.addEventListener('aniarcs:bundle-added', event => {
      if (event.detail.items.some(item => this.ids.has(String(item.id)))) {
        try { sessionStorage.setItem('aniarcs-yukimiya-added', '1'); } catch {}
      }
    }, { signal });
    if (this.data.cartPage) {
      let pending = false;
      try {
        pending = sessionStorage.getItem('aniarcs-yukimiya-added') === '1';
        sessionStorage.removeItem('aniarcs-yukimiya-added');
      } catch {}
      if (pending) this.showForCart(this.data.cart);
    }
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
  }

  eligible(cart) {
    return cart.items.some(item => this.ids.has(String(item.variant_id))) &&
      !cart.items.some(item => String(item.variant_id) === String(this.data.variantId));
  }

  async onCartAdd(event) {
    if (event.action !== 'add' || !event.lines?.some(line => this.ids.has(String(line.merchandiseId).split('/').pop()))) return;
    try {
      const result = await event.promise;
      if (result.detail?.didError) return;
      const response = await fetch(this.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
      if (response.ok) this.showForCart(await response.json());
    } catch {}
  }

  showForCart(cart) {
    if (!this.isConnected || !this.eligible(cart) || this.dialog.open) return;
    const jerseyHandles = new Set(['blue-lock-bastard-munchen-football-tee', 'pxg-tee', 'manshine-city-tee', 'ubers-tee']);
    const jerseyQuantity = cart.items.reduce((sum, item) => sum + (jerseyHandles.has(item.handle) ? item.quantity : 0), 0);
    const bundlePriority = jerseyQuantity > 1;
    const price = bundlePriority ? this.data.price : this.data.price - Math.floor(this.data.price * 0.1);
    this.querySelector('[data-offer-price]').textContent = this.money.format(price / 100);
    this.querySelector('[data-original-price]').hidden = bundlePriority;
    this.querySelector('[data-offer-badge]').textContent = bundlePriority ? this.data.bundlePriority : this.data.save;
    this.error.hidden = true;
    this.dialog.showModal();
  }

  async addGlasses() {
    if (this.pending) return;
    this.pending = true;
    this.button.disabled = true;
    this.button.setAttribute('aria-busy', 'true');
    this.error.hidden = true;
    try {
      const check = await fetch(this.dataset.cartJsonUrl, { headers: { Accept: 'application/json' } });
      if (!check.ok) throw new Error(this.data.error);
      const cart = await check.json();
      if (cart.items.some(item => String(item.variant_id) === String(this.data.variantId))) {
        window.location.assign(this.dataset.cartUrl);
        return;
      }
      if (!this.eligible(cart)) throw new Error(this.data.error);
      const response = await fetch(this.dataset.addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.data.variantId, quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || this.data.error);
      window.location.assign(this.dataset.cartUrl);
    } catch (error) {
      this.error.textContent = error.message || this.data.error;
      this.error.hidden = false;
      this.pending = false;
      this.button.disabled = false;
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('aniarcs-yukimiya-offer')) {
  customElements.define('aniarcs-yukimiya-offer', AniarcsYukimiyaOffer);
}
